// Firebase
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const useE2EAuth = process.env.VUE_APP_E2E_AUTH === "true";
const app = useE2EAuth
  ? null
  : initializeApp({
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.VUE_APP_FIREBASE_APP_ID
    });

const auth = useE2EAuth
  ? {
      currentUser: null,
      signOut() {
        this.currentUser = null;
        return Promise.resolve();
      }
    }
  : getAuth();

export { app, auth, useE2EAuth };
